import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";
import { TableBase, type TableBaseProps } from "@core/ui";

export type Props = Omit<TableBaseProps, "data-testid" | "containerClassName">;

/**
 * Styled table container wrapping TableBase.
 * Provides rounded borders and overflow handling.
 */
export const Table = forwardRef<HTMLTableElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <TableBase
        ref={ref}
        containerClassName={twMerge(
          "relative w-full overflow-auto rounded-md border border-border",
          className
        )}
        className="w-full"
        data-testid="table"
        {...props}
      />
    );
  }
);

Table.displayName = "Table";

export default Table;

